<template>
  <div class="ui container" :class="{ 'fluid': fluid }">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    title: String,
    titleClass: String,
    iconClass: String,
    fluid: { type: Boolean, default: false },
  },
};

</script>
